export default __webpack_public_path__ + "ada09027a3382244b387e3e3cd786655.jpeg";